export default __webpack_public_path__ + "static/media/bomb.edd3010d.svg";